import React, { Component } from 'react';
import './menu.css';
import user from '../../img/circlelogo.png';
import { Link } from 'react-router-dom';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import Modal_Empresa from '../Emp_Empresas/empresa_modal';
import history from '../../history';
import store from '../../store';
import menu from '../../img/menu.png'
import { Offline, Online } from 'react-detect-offline';
import { sendLog } from '../../util'
import logo from '../../img/i-strategies-logo.svg'

class Menu extends Component {

	constructor(props) {
		super(props);
		this.state = {
			mostrar: 'noMostrar',
			tipo_usuario: '',//Admin,empresa o perfil generado
			usuario: firebase.auth().currentUser,
			rutas: props.rutas
		};

		this.handleClick = this.handleClick.bind(this);
		this.renderItemsMenu = this.renderItemsMenu.bind(this);
		this.renderMenuCompleto = this.renderMenuCompleto.bind(this);
		this.renderMenuEmpresa = this.renderMenuEmpresa.bind(this);
		this.selectMenu = this.selectMenu.bind(this);
		this.logout = this.logout.bind(this);


		store.subscribe(() => {


			this.setState({

				mostrar: store.getState().mostrar

			})

		});



	}


	handleClick = () => {

		Alert.closeAll();
		this.setState({
			mostrar: (this.state.mostrar == 'noMostrar' ? 'mostrar' : 'noMostrar')
		});

	}

	renderItemsMenu() {

		// return <li><Link to={x.url}>{x.nombre}</Link></li>
		// console.log(this.state.rutas);
		return (
			<div style={{ height: '100%', width: '100%' }}>
				{this.state.rutas.map(x => {
					return (
						<li><Link to={x.url}><i className={x.iconClass}></i>&nbsp;&nbsp;&nbsp;&nbsp;{x.nombre}</Link></li>)
				}
				)
				}
				<li><Link to="#" onClick={this.logout}><i className="fa fa-sign-out-alt"></i>&nbsp;&nbsp;&nbsp;&nbsp;Cerrar Sesión</Link></li>
			</div>
		);
	}

	renderMenuCompleto() {

		return (
			<div>
				<li><Link to="/informacion"><i className="fa fa-info-circle"></i>&nbsp;&nbsp;&nbsp;&nbsp;Información de empresa</Link></li>
				<li><Link to="/perfiles"><i className="fa fa-user-circle"></i>&nbsp;&nbsp;&nbsp;&nbsp;Perfiles</Link></li>
				<li><Link to="/usuarios"><i className="fa fa-users"></i>&nbsp;&nbsp;&nbsp;&nbsp;Usuarios</Link></li>
				<li><Link to="/tarifasAvianca"><i className="fa fa-money-bill-wave"></i>&nbsp;&nbsp;&nbsp;&nbsp;Tarifas Avianca</Link></li>
				<li><Link to="/empresa"><i className="fa fa-building"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Empresa - Cliente</Link></li>
				<li><Link to="/rutas"><i className="fa fa-map"></i>&nbsp;&nbsp;&nbsp;&nbsp;Rutas</Link></li>
				<li><Link to="/estado_ruta"><i className="fa fa-map-marked-alt"></i>&nbsp;&nbsp;&nbsp;&nbsp;Estado de Rutas</Link></li>
				{/* <li><Link to="/estado_ruta"><i className="fa fa-user-alt"></i>&nbsp;&nbsp;&nbsp;&nbsp;Asignación de Conductores</Link></li> */}
				<li><Link to="/editar_viaje"><i className="fa fa-edit"></i>&nbsp;&nbsp;&nbsp;&nbsp;Viajes</Link></li>
				<li><Link to="/nuevoViajeA"><i className="fa fa-map-marked"></i>&nbsp;&nbsp;&nbsp;&nbsp;Programación</Link></li>
				<li><Link to="/tipos_vehiculos"><i className="fa fa-bus"></i>&nbsp;&nbsp;&nbsp;&nbsp;Tipos de Vehiculos</Link></li>
				<li><Link to="/vehiculos"><i className="fa fa-car"></i>&nbsp;&nbsp;&nbsp;&nbsp;Vehiculos</Link></li>
				<li><Link to="/empleados"><i className="fa fa-address-card"></i>&nbsp;&nbsp;&nbsp;&nbsp;Conductores</Link></li>
				<li><Link to="/reportes"><i className="fa fa-chart-bar"></i>&nbsp;&nbsp;&nbsp;&nbsp;Reportes</Link></li>
				<li><Link to="/reporte_operacionalA"><i className="fa fa-chart-line"></i>&nbsp;&nbsp;&nbsp;&nbsp;Reporte Operacional</Link></li>
				<li><Link to="#" onClick={this.logout}><i className="fa fa-sign-out-alt"></i>&nbsp;&nbsp;&nbsp;&nbsp;Cerrar Sesión</Link></li>
			</div>
		);


	}


	renderMenuEmpresa() {



		let uid = firebase.auth().currentUser !== null ? firebase.auth().currentUser.uid : '';

		return (
			<div>
				<li><Link to="/nuevoViaje"><i className="fa fa-map-marked-alt"></i>&nbsp;&nbsp;&nbsp;&nbsp;Programación</Link></li>
				<li><Link to="/costos"><i class="fas fa-building"></i>&nbsp;&nbsp;&nbsp;&nbsp;Centro de costos</Link></li>
				<li><Link to="/empleados"><i class="fas fa-users"></i>&nbsp;&nbsp;&nbsp;&nbsp;Empleados</Link></li>
				<li><Link to="/estado_ruta"><i className="fa fa-map-marked-alt"></i>&nbsp;&nbsp;&nbsp;&nbsp;Estado de Rutas</Link></li>
				<li><Link to="/reporte_operacionalA"><i className="fa fa-chart-line"></i>&nbsp;&nbsp;&nbsp;&nbsp;Reporte Operacional</Link></li>
				<Modal_Empresa nodo={uid} onClick={this.handleClick} />
				<li><Link to="#" onClick={this.logout}><i className="fa fa-sign-out-alt"></i>&nbsp;&nbsp;&nbsp;&nbsp;Cerrar Sesión</Link></li>
			</div>

		);


	}

	renderMenuEmpleado() {
		return (
			<div>
				<li><Link to="#" onClick={this.logout}><i className="fa fa-sign-out-alt"></i>Cerrar Sesión</Link></li>
			</div>
		);
	}



	renderMenuSocios() {
		return (
			<div>
				<li><Link to="/reporte_viajes_conductores">Viajes por conductor</Link></li>
				<li><Link to="/reporte_conductores">Conductores</Link></li>
				<li><Link to="/reporte_vehiculos">Vehiculos</Link></li>
				<li><Link to="#" onClick={this.logout}>Cerrar Sesión</Link></li>
			</div>
		);
	}


	selectMenu() {


		if (this.state.rutas === 'admin') {

			this.renderMenuCompleto();


		}
		else if (this.state.rutas === 'empresa') {

			this.renderMenuEmpresa();

		}
		else {

			this.renderItemsMenu(this.state.rutas);
			// this.state.rutas.map(this.renderItemsMenu)

		}



	}

	async logout() {

		const isUid = !!localStorage.getItem('uid');
		sendLog({ tipo: 'logout', informacion_extra: { usuario: isUid } });
		if (isUid) {
			localStorage.removeItem('uid');
			await firebase.database().ref(`/Usuarios_Acacya/${firebase.auth().currentUser.uid}/session_uid`).set("");

		}


		firebase.auth().signOut().then(function () {

			history.push("/");

		}).catch(function (error) {

		});

	}


	render() {
		if (this.state.rutas !== 'empleado') {
			return (
				<div>
					<Offline>
						<div id="mostrar-nav" style={{ marginTop: "40px" }} onClick={this.handleClick}></div>
					</Offline>
					<Online>
						<div id="mostrar-nav" onClick={this.handleClick}></div>
					</Online>
					<nav className={this.state.mostrar} onClick={this.handleClick}>
						<div className="logoHeader">
							<img src={logo} />
						</div>
						<div className="user-area">
							<img src={user} className='profile-img' />
							<p className="userName" style={{ marginTop: '1%', }}>{this.props.usuario}</p>
						</div>
						<div className="separador"></div>
						<ul className="menu">
							{(this.state.rutas === 'socios') ? this.renderMenuSocios() : (this.state.rutas === 'empresa') ? this.renderMenuEmpresa() : (this.state.rutas === 'admin') ? this.renderMenuCompleto() : this.renderItemsMenu()}
						</ul>
					</nav>
				</div>
			);
		}
		else {
			return (
				<div>
					<div id="nav-negro" onClick={this.handleClick}>
						<img className='imgL' src={menu} alt="menu" />
					</div>
					<nav className={this.state.mostrar} onClick={this.handleClick}>
						<div className="user-area">
							<img src={user} className='profile-img' />
							<p className="userName" style={{ marginTop: '1%' }}>{this.props.usuario}</p>
						</div>
						<div className="separador"></div>
						<ul className="menu">
							{(this.state.rutas === 'empleado') ? this.renderMenuEmpleado() : this.renderItemsMenu()}
						</ul>
					</nav>
				</div>
			)
		}
	}
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.jsx